import { type AnalyticsClient } from '@databases/analytics';
import type { AddFlagProps } from '@databases/flags-types';
import type { MessageFormatter } from '@databases/intl/intl-types';
import type { ShowPanelType } from '@databases/panel/PanelContext';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

export enum MentionFlagType {
  SUCCESS = 'success',
  RESTRICTED = 'restricted',
  ERROR = 'error',
}

type Mention = {
  mentionLocalId: string;
  mentionedUserAccountId: string;
  displayName: string;
};

export type UseMentionNotificationProps = {
  contentId: string;
};

export type CreateMentionNotificationProps = {
  mentions: Mention[];
  fieldId: string;
};

export type CreateMentionNotificationType = (
  params: CreateMentionNotificationProps
) => Promise<void>;

export type Permissions = {
  userHasAccessToContent: boolean;
  isParentDatabaseRestricted: boolean;
  isSpaceRestricted: boolean;
};

export type User = {
  displayName: string;
  mentionLocalId: string;
  mentionedUserAccountId: string;
  profilePicture: string;
  permissions: Permissions;
};

export type CheckContentPermissionsProps = {
  accountIds: string[];
  contentId: string;
};

export type IdentifyNotificationEligibleUsersProps = {
  contentId: string;
  mentions: Mention[];
};

export type GetDisplayNameForUsersProps = {
  users: User[];
};

export type BuildProps = {
  formatMessage: MessageFormatter;
  usersWithAccess: User[];
  usersWithoutAccess: User[];
  isLocked: boolean;
  showPanel: ShowPanelType;
  fieldId: string;
  analyticsClient: AnalyticsClient;
  contentId: string;
};

export interface MentionBuilder {
  shouldShowFlag(): boolean;
  build(): AddFlagProps & ContentTypesFlagProps;
}
